import moment from "moment";

export default {
  methods: {
    // METER
    meterUnitName(val, type, error = 0) {
      let _unitName = "";
      switch (type) {
        case "TOTAL":
          _unitName = `
            <span class="blink--text"> ${val} </span>
            <span class="text--digital--verySmall"> m<sup>3</sup> </span>
            `;
          break;
        case "FLOW":
          _unitName = `
              <span class="blink--text"> ${val} </span>
              <span class="text--digital--verySmall"> m<sup>3</sup>/hr </span>`;
          break;
        case "LEVEL":
          _unitName = `
            <span class="blink--text"> ${val} </span>
            <span class="text--digital--verySmall"> m </span>`;
          break;
        case "TDS":
          _unitName = `
            <span class="blink--text"> ${val} </span>
            <span class="text--digital--verySmall"> PPM </span>`;
          break;
        case "EC":
          _unitName = `
            <span class="blink--text"> ${val} </span>
            <span class="text--digital--verySmall"> μS/cm </span>`;
          break;
        case "PRS":
          _unitName = `
            <span class="blink--text"> ${val} </span>
            <span class="text--digital--verySmall"> Bar </span>`;
          break;

        default:
          _unitName = `<span class="text-letGoDigital white--text"> ${error} </span>`;
          break;
      }
      return _unitName;
    },
    meterChanged(varName, from, to, optTofixed=2) {
      let numberTweenTime = 200;
      from = from || 0;
      let increment = (to - from) / (numberTweenTime / 10);

      let intervalLevel = setInterval(function() {
        from += increment;

        eval(varName + " = " + from.toFixed(optTofixed));

        if (
          (increment > 0 && from >= to) ||
          (increment < 0 && from <= to) ||
          increment == 0
        ) {
          eval(varName + " = " + to.toFixed(optTofixed));
          clearInterval(intervalLevel);
        }
      }.bind(this), 1);
    },
    renderValMeter(val) {
      if (val && val !== "Error") {
        return val.toFixed(2);
      } else {
        return "ERROR";
      }
    },

    // METER CALIBRATE
    // ? from CSS style range in [-25, 75] (max, min)
    // * [FORMULAR] : resCalibrate = (decreaseRange from 100 (100-25))-(val*100/max)
    calibrateWaterLevelPerc(val, max) {
      return 75-(val*100/max);
    },
    convertWaterLevelWithTds(val) {
      if (val != null) {
        if (val < 0) {
          return 100;
        } else if (val > 10) {
          return 0;
        } else {
          return Math.abs((val*10-100));
        }
      } else {
        return null;
      }
    },
    convertWaterLevelPercentToMeter(val) {
      if (val != null) {
        if (val > 100) {
          return 100;
        } else if (val < 0) {
          return 0;
        } else {
          return (Math.abs((val-100))/10).toFixed(2);
        }
      } else {
        return null;
      }
    },

    // SCREEN RESOLUTION
    onResize() {
      // console.log('OnResize');
      this.screenHeight = window.innerHeight;
      this.screenWidth = window.innerWidth;
    },

    // DATETIME
    displayDate(date) {
      return moment(date, "YYYY-MM-DD").format("วันddddที่ Do MMMM YYYY");
    },
  },
}
